import { DayWiseOpCompletionModel } from "./day-wise-op-completion.model";
import { PoWiseOrderQtyModel } from "./order-completion-qty/po-wise-order-qty.model";

export class OpDeliveryDateWiseCompletionModel {
    deliverDate: string;
    dayWiseOpCompletionModel?: DayWiseOpCompletionModel[];

    weekWiseCompletionModel?: DayWiseOpCompletionModel;
    monthWiseCompletionModel?: DayWiseOpCompletionModel;

    allPos: string[];
    completedPos: string[];

    allSchedules: string[];
    completedSchedules: string[];

    buyers: string[]; // all the buyers for that delivery date

    cutCompletedDate: string; // the last cut completed date within the delivery date related POs

    poWiseFullPlanQtys: PoWiseOrderQtyModel[];

    constructor(deliverDate: string, allPos: string[], completedPos: string[], allSchedules: string[], completedSchedules: string[], buyers: string[], cutCompletedDate: string, poWiseFullPlanQtys: PoWiseOrderQtyModel[], dayWiseOpCompletionModel?: DayWiseOpCompletionModel[], weekWiseCompletionModel?: DayWiseOpCompletionModel, monthWiseCompletionModel?: DayWiseOpCompletionModel) {
        this.deliverDate = deliverDate;
        this.allPos = allPos;
        this.completedPos = completedPos;
        this.allSchedules = allSchedules;
        this.completedSchedules = completedSchedules;
        this.buyers = buyers;
        this.poWiseFullPlanQtys = poWiseFullPlanQtys;
        this.dayWiseOpCompletionModel = dayWiseOpCompletionModel;
        this.weekWiseCompletionModel = weekWiseCompletionModel;
        this.monthWiseCompletionModel = monthWiseCompletionModel;
    }
}

// response -> delverydates -> each day wise info -> operation category -> po wise -> schedule wise


// response -> delverydates -> each day wise info -> po wise -> schedule wise -> op level qtys

